import styled from 'styled-components';
import { H3 } from 'UIComponents/elements/headings';
import UIIllustration from 'UIComponents/image/UIIllustration';
import UISection from 'UIComponents/section/UISection';
import ContentControlWrapper from '../../../components/ContentControlWrapper';
import ContentViewport from '../../../components/ContentViewport';
import { device } from '../../../constants/StyledComponentConstants';
import ExamFinishedSecondaryButtons from './ExamFinishedSecondaryButtons';
import PracticalExercisesOutstanding from './PracticalExercisesOutstanding';
import ExamLoadingScreen from './ExamLoadingScreen';
import ExamErrorScreen from './ExamErrorScreen';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BASE_CLASS_NAME = 'exam-finished-screen';
const StyledUIIllustration = styled(UIIllustration).withConfig({
  displayName: "ExamFinishedScreenLayout__StyledUIIllustration",
  componentId: "oe2ewc-0"
})(["margin-right:50px;margin-left:50px;@media screen and ", "{display:none;}"], device.tablet);
const ExamFinishedScreenLayout = ({
  illustration,
  heading,
  subheading,
  prompt,
  callToAction,
  trackId,
  loading,
  error,
  showSecondaryRetakeCTA,
  language
}) => {
  if (loading) return /*#__PURE__*/_jsx(ExamLoadingScreen, {});
  if (error) return /*#__PURE__*/_jsx(ExamErrorScreen, {
    error: error
  });
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(ContentViewport, {
      wrapperClassName: `${BASE_CLASS_NAME}__content-viewport`,
      children: /*#__PURE__*/_jsxs("div", {
        style: {
          display: 'flex'
        },
        children: [/*#__PURE__*/_jsx(StyledUIIllustration, {
          name: illustration
        }), /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx(H3, {
            "data-test-id": "exam-finished-screen-heading",
            children: heading
          }), /*#__PURE__*/_jsx(UISection, {
            "data-test-id": "exam-finished-screen-subheading",
            children: subheading
          }), prompt && /*#__PURE__*/_jsx(UISection, {
            children: prompt
          }), callToAction && /*#__PURE__*/_jsx(UISection, {
            "data-test-id": "exam-finished-screen-primary-ctas",
            children: callToAction
          }), /*#__PURE__*/_jsx(PracticalExercisesOutstanding, {
            trackId: trackId
          })]
        })]
      })
    }), /*#__PURE__*/_jsx(ContentControlWrapper, {
      className: `${BASE_CLASS_NAME}__content-control`,
      children: /*#__PURE__*/_jsx(ExamFinishedSecondaryButtons, {
        language: language,
        retake: showSecondaryRetakeCTA,
        trackId: trackId
      })
    })]
  });
};
export default ExamFinishedScreenLayout;